/** InsCoder WANG.J 2026-02-01 B + M2 Subscription Section Scripts **/

(function() {
  'use strict';

  // Success Popup elements
  var popupOverlay = null;
  var popup = null;
  var closeBtn = null;

  // Terms Popup elements
  var termsOverlay = null;
  var termsPopup = null;
  var termsCloseBtn = null;
  var termsTriggers = null;

  /**
   * Initialize popup elements
   */
  function initPopupElements() {
    var section = document.querySelector('.cust-m2-subscription');
    if (!section) return false;

    // Success popup elements
    popupOverlay = section.querySelector('.cust-m2-subscription__popup-overlay');
    popup = section.querySelector('.cust-m2-subscription__popup');
    closeBtn = section.querySelector('.cust-m2-subscription__popup-close');

    // Terms popup elements
    termsOverlay = section.querySelector('.cust-m2-subscription__terms-overlay');
    termsPopup = section.querySelector('.cust-m2-subscription__terms-popup');
    termsCloseBtn = section.querySelector('.cust-m2-subscription__terms-popup-close');
    termsTriggers = section.querySelectorAll('.cust-m2-subscription__terms-trigger');

    if (!popupOverlay || !popup) return false;

    // Bind success popup close events
    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }
    popupOverlay.addEventListener('click', closePopup);

    // Bind terms popup events
    if (termsOverlay && termsPopup) {
      if (termsCloseBtn) {
        termsCloseBtn.addEventListener('click', closeTermsPopup);
      }
      termsOverlay.addEventListener('click', closeTermsPopup);

      // Bind terms triggers
      termsTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          openTermsPopup();
        });
      });
    }

    // ESC key closes active popup
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (termsPopup && termsPopup.classList.contains('is-active')) {
          closeTermsPopup();
        } else {
          closePopup();
        }
      }
    });

    return true;
  }

  /**
   * Open the success popup
   */
  function openPopup() {
    if (!popupOverlay || !popup) return;
    
    popupOverlay.classList.add('is-active');
    popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    
    console.log('[M2 Subscription] Popup opened');
  }

  /**
   * Close the success popup
   */
  function closePopup() {
    if (!popupOverlay || !popup) return;
    
    popupOverlay.classList.remove('is-active');
    popup.classList.remove('is-active');
    document.body.style.overflow = '';
    
    console.log('[M2 Subscription] Popup closed');
  }

  /**
   * Open the terms popup
   */
  function openTermsPopup() {
    if (!termsOverlay || !termsPopup) return;
    
    termsOverlay.classList.add('is-active');
    termsPopup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    
    console.log('[M2 Subscription] Terms popup opened');
  }

  /**
   * Close the terms popup
   */
  function closeTermsPopup() {
    if (!termsOverlay || !termsPopup) return;
    
    termsOverlay.classList.remove('is-active');
    termsPopup.classList.remove('is-active');
    // Only restore overflow if success popup is not open
    if (!popup || !popup.classList.contains('is-active')) {
      document.body.style.overflow = '';
    }
    
    console.log('[M2 Subscription] Terms popup closed');
  }

  /**
   * Watch for Form Builder initialization
   * Monitors for form.g-container element and binds reset event
   */
  function initFormWatcher() {
    var formContainer = document.querySelector('.cust-m2-subscription');
    if (!formContainer) return;

    // Initialize popup elements
    initPopupElements();

    // MutationObserver to watch for form.g-container element
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              checkForFormContainer(node);
            }
          });
        }
      });
    });

    // Start observing
    observer.observe(formContainer, {
      childList: true,
      subtree: true
    });

    // Also check if form already exists
    var existingForm = formContainer.querySelector('form.g-container');
    if (existingForm) {
      bindFormResetEvent(existingForm);
    }
  }

  /**
   * Check if the node is or contains form.g-container
   * @param {Node} node - DOM node to check
   */
  function checkForFormContainer(node) {
    var form = null;
    
    // Check if the node itself is the form
    if (node.matches && node.matches('form.g-container')) {
      form = node;
    } else if (node.querySelector) {
      // Check if the node contains the form
      form = node.querySelector('form.g-container');
    }

    if (form) {
      bindFormResetEvent(form);
    }
  }

  /**
   * Bind reset event to the form
   * @param {HTMLFormElement} form - Form element
   */
  function bindFormResetEvent(form) {
    // Prevent duplicate binding
    if (form.dataset.resetBound) return;
    form.dataset.resetBound = 'true';

    form.addEventListener('reset', function(e) {
      console.log('[M2 Subscription] Form reset triggered');
      
      // Show success popup when form is reset (after successful submission)
      openPopup();
    });

    console.log('[M2 Subscription] Form found and reset event bound:', form);
  }

  // Expose functions globally for external use
  window.CustM2Subscription = {
    openPopup: openPopup,
    closePopup: closePopup,
    openTermsPopup: openTermsPopup,
    closeTermsPopup: closeTermsPopup
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormWatcher);
  } else {
    initFormWatcher();
  }

})();

/** InsCoder WANG.J 2026-02-01 E + M2 Subscription Section Scripts **/
